'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { Content } from '@radix-ui/react-tabs';
import { forwardRef } from 'react';
import { cn } from '../../utils/cn';
const TabsContent = forwardRef(({ className, ...props }, ref) => (_jsx(Content, { ref: ref, className: cn('mt-2 focus-visible:outline-none', className), ...props })));
TabsContent.displayName = Content.displayName;
export { TabsContent };
